module.exports = __webpack_public_path__ + "static/media/AppLogo.b9cf4e36.svg";